<template>
  <div
    ref="searchBoxRef"
    class="x-input-group x-input-group-lead x-rounded-sm x-border-none x-bg-neutral-10"
  >
    <SearchInput
      :placeholder="$t('searchBox.placeholder')"
      :instant="true"
      class="desktop:!x-pl-24"
    />

    <ClearSearchInput
      v-if="isDesktopOrGreater && x.query.searchBox"
      class="x-input-group-button x-input-group-button-rectangle"
    >
      {{ $t('searchBox.clear') }}
    </ClearSearchInput>

    <SearchButton
      v-if="isDesktopOrGreater || !x.query.searchBox"
      class="x-input-group-button-primary"
    >
      <SearchIcon class="x-icon-md" />
    </SearchButton>

    <ClearSearchInput v-else class="x-input-group-button-primary">
      <CrossTinyIcon class="x-icon-lg" />
    </ClearSearchInput>
  </div>
</template>

<script setup lang="ts">
import { CrossTinyIcon, SearchIcon, use$x } from '@empathyco/x-components'
import { ClearSearchInput, SearchButton, SearchInput } from '@empathyco/x-components/search-box'
import { onMounted, ref } from 'vue'
import { useDevice } from '../composables/use-device.composable'

const { isDesktopOrGreater } = useDevice()
const x = use$x()
const searchBoxRef = ref<HTMLElement | null>(null as any)

onMounted(() => {
  setTimeout(() => {
    searchBoxRef.value?.querySelector('input')?.focus()
  }, 0)
})
</script>
